// removed by extract-text-webpack-plugin
module.exports = {"FirstScreen":"FirstScreen__FirstScreen__3rLs5","Show":"FirstScreen__Show__32rbO","BackgroundContainer":"FirstScreen__BackgroundContainer__OT9kF","CentralButtonContainer":"FirstScreen__CentralButtonContainer__3ieed","CentralButton":"FirstScreen__CentralButton__1DN_I"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FirstScreen/FirstScreen.css
// module id = 212
// module chunks = 0